var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardTitleContainer",
    {
      staticClass: "mr-2",
      attrs: { routeParams: _vm.employeePageRouteParams },
    },
    [
      _c("span", { staticClass: "flex flex-wrap" }, [
        _c("span", { staticClass: "truncate mr-1" }, [
          _vm._v(_vm._s(_vm.givenName)),
        ]),
        _c("span", { staticClass: "truncate" }, [
          _vm._v(_vm._s(_vm.familyName)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }